import styled from 'styled-components';

const Page = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.gray[100]};
  gap: 16px;
  background-color: ${({ theme }) => (theme.gray[900])};
  padding: 16px;
`;

export default Page;
